/** Mensagens para os códigos padronizados das RPCs admin_* (docs/reference/super-admin.md). */
const MENSAGENS: Record<string, string> = {
  LT001: 'Limite de telas atingido para esta empresa.',
  MD001: 'Este recurso não está disponível no seu plano.',
  '42501': 'Sem permissão para esta ação.',
  P0002:   'Registro não encontrado.',
  '23505': 'Já existe um registro com esse nome.',
  '22023': 'Dados inválidos.',
  '23503': 'Registro em uso. Remova as referências antes de excluir.',
  CP001:   'Nenhuma tela atingida: o alvo está vazio ou todo bloqueado por concorrente.',
  CP002:   'Envie o arquivo da campanha antes de publicar.',
  CP003:   'O período da campanha já terminou.',
  CP004:   'Encerre as campanhas agendadas ou no ar deste anunciante antes de arquivar.',
  CP005:   'O anunciante desta campanha está arquivado. Reative-o antes de publicar.',
  CP006:   'Publique a campanha antes de gerar o link.',
  CP007:   'Passaram 30 dias do fim da campanha: o link não pode mais ser gerado.',
};

const MENSAGEM_PADRAO = 'Não foi possível concluir a ação. Tente novamente.';

/** Converte erro do PostgREST/Postgres em Error com mensagem amigável; nunca expõe o texto cru. */
export function traduzirErroAdmin(err: unknown): Error {
  const code = typeof err === 'object' && err !== null && 'code' in err
    ? String((err as { code: unknown }).code)
    : '';
  return new Error(MENSAGENS[code] ?? MENSAGEM_PADRAO);
}
